import { CheckCircle2 } from "lucide-react";
import { MASCOT_FACE_URL, META_PHONE } from "@/config/brand";
import { Reveal } from "@/components/Reveal";

const ThankYouPage = () => (
  <main data-testid="thank-you-page" className="flex min-h-[80vh] items-center">
    <div className="mx-auto max-w-2xl px-5 py-24 text-center md:px-10">
      <Reveal>
        <img
          src={MASCOT_FACE_URL}
          alt="Same Day Home Services tradie"
          className="mx-auto w-28 rounded-full border-2 border-sdh-sky/50 md:w-32"
          data-testid="thank-you-mascot"
        />
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-8 flex justify-center">
          <CheckCircle2 size={44} className="text-sdh-sky" />
        </div>
        <h1 className="mt-5 font-display text-5xl uppercase leading-[0.95] tracking-tight text-white md:text-7xl">
          Thanks — we'll be in touch.
        </h1>
        <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-white/70 md:text-lg">
          Your enquiry has landed with our team. A real person will call you back shortly.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-10 rounded-3xl border border-sdh-sky/30 bg-sdh-sky/[0.08] p-7 md:p-9">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-sdh-sky">
            Want to chat sooner?
          </p>
          <p className="mt-3 text-base text-white/75 md:text-lg">
            Speak directly to our bathroom designers:
          </p>
          <a
            href={`tel:${META_PHONE.replace(/[^0-9]/g, "")}`}
            data-testid="thank-you-phone"
            className="mt-4 inline-block font-display text-4xl tracking-wide text-white transition-colors duration-300 hover:text-sdh-sky md:text-5xl"
          >
            {META_PHONE}
          </a>
        </div>
      </Reveal>
      <Reveal delay={0.3}>
        <a
          href="/"
          data-testid="thank-you-home-link"
          className="mt-10 inline-block text-sm font-semibold text-white/50 transition-colors duration-300 hover:text-sdh-sky"
        >
          ← Back to home
        </a>
      </Reveal>
    </div>
  </main>
);

export default ThankYouPage;
